module.exports = __webpack_public_path__ + "img/thumb_6.18c6fcb1.jpg";